var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 371.22,
    height: 21.36,
    viewBox: "0 0 371.22 21.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306,21.36c-24.61-7.49-96.33-9.68-136.9-10.32-48.1-.76-93.06-.03-105.19.77-1.15.16-2.27.32-3.38.48l-.71.11-.6-1.23.43-.53c.18-.21.41-.48,3.78-.75C113.2,3.02,192.92,3.43,251.65,5.01c29.75.8,57.19,1.98,78.26,3.02C173.09-5.57,2.02,7.95.16,8.11l-.16-1.97c2.03-.16,204.65-16.18,371.22,4.2l-.18,1.96c-1.94-.13-177.31-11.5-280.64-3.28.92-.02,1.88-.03,2.86-.04,13.12-.2,40.2-.45,74.04.06,41.25.62,114.2,2.81,139.28,10.44l-.57,1.89Z",
    fill: "red",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineRed);
export default __webpack_public_path__ + "static/media/underline-red.6cff0d8d458c59915bea6e369ac5bf6e.svg";
export { ForwardRef as ReactComponent };